import { render, staticRenderFns } from "./StudipMessageBox.vue?vue&type=template&id=e918f6d8&"
import script from "./StudipMessageBox.vue?vue&type=script&lang=js&"
export * from "./StudipMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports